import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const formatCurrency = (value) =>
  new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND', maximumFractionDigits: 0 }).format(
    Number(value || 0),
  );

const ForceCheckoutModal = ({ show, shift, onConfirm, onHide, loading }) => {
  const [closingCash, setClosingCash] = useState('');
  const [notes, setNotes] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      setClosingCash(shift?.expectedClosing != null ? String(shift.expectedClosing) : '');
      setNotes('');
      setError('');
    }
  }, [show, shift]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const amount = Number(closingCash);
    if (Number.isNaN(amount) || amount < 0) {
      setError('Số tiền không hợp lệ');
      return;
    }
    setError('');
    onConfirm({ closingCash: amount, notes: notes.trim() });
  };

  const diff = closingCash !== '' ? Number(closingCash) - (shift?.expectedClosing || 0) : null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Đóng ca thay</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted small mb-3">
            Ca của <strong>{shift?.employeeName}</strong> — {shift?.branchName}
          </p>
          <div className="mb-3 p-3 bg-light rounded">
            <div className="d-flex justify-content-between small">
              <span className="text-muted">Tiền đầu ca</span>
              <span>{formatCurrency(shift?.openingCash)}</span>
            </div>
            <div className="d-flex justify-content-between small">
              <span className="text-muted">Doanh thu tiền mặt</span>
              <span>{formatCurrency(shift?.cashRevenue)}</span>
            </div>
            <div className="d-flex justify-content-between small">
              <span className="text-muted">Phiếu chi</span>
              <span>-{formatCurrency(shift?.cashExpenses)}</span>
            </div>
            <hr className="my-2" />
            <div className="d-flex justify-content-between small fw-semibold">
              <span>Tiền dự kiến cuối ca</span>
              <span>{formatCurrency(shift?.expectedClosing)}</span>
            </div>
          </div>
          <Form.Group className="mb-3">
            <Form.Label>Tiền thực tế cuối ca (VNĐ) *</Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="1000"
              value={closingCash}
              onChange={(e) => { setClosingCash(e.target.value); setError(''); }}
              isInvalid={!!error}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
            {diff !== null && (
              <Form.Text className={diff >= 0 ? 'text-success' : 'text-danger'}>
                Chênh lệch: {diff >= 0 ? '+' : ''}{formatCurrency(diff)}
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group>
            <Form.Label>Ghi chú (tuỳ chọn)</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Lý do đóng ca thay..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Hủy
          </Button>
          <Button type="submit" variant="danger" disabled={loading}>
            {loading ? 'Đang xử lý...' : 'Xác nhận đóng ca'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ForceCheckoutModal;
